var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col", staticStyle: { height: "100%" } },
    [
      _vm.showSearch
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-justify-center flex-align-start flex-1 color-bg-fff padding-y-30",
            },
            [
              _c(
                "div",
                {
                  staticClass: "search color-bg-fff flex-center",
                  class: { serachInput_active: _vm.isFocus },
                },
                [
                  _c("el-input", {
                    staticClass: "margin-left-20",
                    attrs: { placeholder: "请输入用户手机号", maxlength: "11" },
                    on: { focus: _vm.onFocus, blur: _vm.onBlur },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.mobilePhone,
                      callback: function ($$v) {
                        _vm.mobilePhone = $$v
                      },
                      expression: "mobilePhone",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "search-btn flex-center",
                      on: { click: _vm.onSearch },
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "28px", height: "28px" },
                        attrs: {
                          src: require("./static/icon_home_search.png"),
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "color-bg-fff",
          staticStyle: { "min-height": "40%" },
          attrs: { "element-loading-text": "正在加载中～" },
        },
        [_vm.infoShow ? _c("user-detail") : _vm._e()],
        1
      ),
      _c("hit-label"),
      _c("send-score"),
      _c("send-coupon-add", { ref: "couponAdd" }),
      _c("score-statistics-table"),
      _c("growth-statistics-table"),
      _c("intercity-order", { ref: "interCityInfo" }),
      _c("ferry-order", { ref: "ferryOrderInfo" }),
      _c("express-order", { ref: "expressOrderInfo" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }